import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}><path data-name="Path 3094" d="M24 13.5H5.745l8.37 8.385L12 24 0 12 12 0l2.13 2.115L5.745 10.5H24z" fill="rgba(0,0,0,0.6)" /></svg>);